import React, { useState } from 'react';

const horariosDia = [
  '08:00','08:30','09:00','09:30','10:00','10:30',
  '11:00','11:30','12:00','12:30','13:00','13:30',
  '14:00','14:30','15:00','15:30','16:00','16:30',
  '17:00','17:30','18:00','18:30','19:00','19:30'
];

// Serviços padrão usados como fallback quando a barbearia não tem serviços cadastrados
const SERVICOS_FALLBACK = [
  { nome: 'Corte + Barba', preco: 'R$ 75' },
  { nome: 'Só o Corte',    preco: 'R$ 50' },
  { nome: 'Só a Barba',    preco: 'R$ 45' },
];

function formatTelefone(raw) {
  const d = raw.replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return '(' + d;
  let r = '(' + d.slice(0, 2) + ') ';
  if (d.length <= 7) return r + d.slice(2);
  r += d.slice(2, 7) + '-' + d.slice(7);
  return r;
}

function AgendamentoManual({
  horario,
  barbeiro,
  dia,
  mes,
  meses,
  getDiasSemana,
  onSalvar,
  onSalvarMultiplos,
  onFechar,
  // Props com dados reais da barbearia:
  barbeirosLista = [],   // string[] — nomes dos barbeiros
  servicosLista  = [],   // {nome, preco, duracao}[] — serviços do Firestore
  tipoInicial,           // 'bloqueado' | undefined — abre direto no modo bloqueio
  periodoBlockInicial,   // 'periodo' | undefined — pré-seleciona o modo período
  todosAgends    = [],   // todos os agendamentos — para detectar conflitos no período
}) {
  // Barbeiros: usa os reais se disponíveis, senão fallback
  const barbeiros = barbeirosLista.length > 0
    ? barbeirosLista
    : ['Barbeiro 1'];

  // Serviços: usa os reais se disponíveis, senão fallback
  const servicos = servicosLista.length > 0
    ? servicosLista.map(s => ({
        nome: s.nome,
        preco: s.preco?.startsWith('R$') ? s.preco : (s.preco ? `R$ ${s.preco}` : '')
      }))
    : SERVICOS_FALLBACK;

  const primeiroServico = servicos[0] || SERVICOS_FALLBACK[0];

  const [nome,               setNome]               = useState('');
  const [telefoneRaw,        setTelefoneRaw]        = useState('');
  const [servico,            setServico]            = useState(primeiroServico.nome);
  const [confirmPeriodo,     setConfirmPeriodo]     = useState(null); // { conflitos[], lista[] }
  const [preco,            setPreco]            = useState(primeiroServico.preco);
  const [tipo,             setTipo]             = useState(tipoInicial || 'cliente');
  const [barbeiroBloqueio, setBarbeiroBloqueio] = useState(barbeiro);
  const [periodoBlock,     setPeriodoBlock]     = useState(periodoBlockInicial || 'horario');

  const [mesSeletor,    setMesSeletor]    = useState(mes);
  const [dataInicio,    setDataInicio]    = useState(null);
  const [dataFim,       setDataFim]       = useState(null);
  const [selecionando,  setSelecionando]  = useState('inicio');

  const mesIdx    = meses.indexOf(mesSeletor);
  const diasDoMes = getDiasSemana(mesSeletor);

  // ── Estilos ──
  const inputStyle = {
    width: '100%', padding: '12px', borderRadius: '10px',
    border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
    color: '#e8e8e8', fontSize: '14px', boxSizing: 'border-box',
    outline: 'none', fontFamily: 'Arial, sans-serif'
  };

  const labelStyle = {
    fontSize: '10px', color: '#9c9c9c', letterSpacing: '1px',
    textTransform: 'uppercase', display: 'block', marginBottom: '5px'
  };

  // ── Range de datas ──
  function isDentroDoRange(mesNome, numDia) {
    if (!dataInicio || !dataFim) return false;
    const mesI = dataInicio.mesIdx;
    const mesF = dataFim.mesIdx;
    const dI   = parseInt(dataInicio.dia);
    const dF   = parseInt(dataFim.dia);
    const mesA = meses.indexOf(mesNome);
    const dA   = parseInt(numDia);
    if (mesA < mesI || mesA > mesF) return false;
    if (mesA === mesI && mesA === mesF) return dA >= dI && dA <= dF;
    if (mesA === mesI) return dA >= dI;
    if (mesA === mesF) return dA <= dF;
    return true;
  }

  function isInicio(mesNome, numDia) {
    return dataInicio && dataInicio.mes === mesNome && dataInicio.dia === numDia;
  }

  function isFim(mesNome, numDia) {
    return dataFim && dataFim.mes === mesNome && dataFim.dia === numDia;
  }

  function selecionarDia(mesNome, numDia) {
    const ano = new Date().getFullYear();
    const hoje = new Date();
    const hojeZero = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
    const dt = new Date(ano, meses.indexOf(mesNome), parseInt(numDia));
    if (dt < hojeZero) return; // não permite datas passadas
    const item = { mes: mesNome, dia: numDia, mesIdx: meses.indexOf(mesNome) };
    if (selecionando === 'inicio') {
      setDataInicio(item);
      setDataFim(null);
      setSelecionando('fim');
    } else {
      const inicioAntes = dataInicio &&
        (meses.indexOf(mesNome) > dataInicio.mesIdx ||
        (meses.indexOf(mesNome) === dataInicio.mesIdx && parseInt(numDia) >= parseInt(dataInicio.dia)));
      if (inicioAntes) {
        setDataFim(item);
        setSelecionando('inicio');
      } else {
        setDataInicio(item);
        setDataFim(null);
      }
    }
  }

  function gerarListaBloqueio() {
    if (!dataInicio) return [];
    const fim = dataFim || dataInicio;
    const lista = [];
    const mesI = dataInicio.mesIdx;
    const mesF = fim.mesIdx;
    for (let m = mesI; m <= mesF; m++) {
      const diasMes = getDiasSemana(meses[m]);
      diasMes.forEach(d => {
        const dNum = parseInt(d.num);
        if (m === mesI && m === mesF) {
          if (dNum < parseInt(dataInicio.dia) || dNum > parseInt(fim.dia)) return;
        } else if (m === mesI) {
          if (dNum < parseInt(dataInicio.dia)) return;
        } else if (m === mesF) {
          if (dNum > parseInt(fim.dia)) return;
        }
        horariosDia.forEach(h => {
          lista.push({
            barbeiro: barbeiroBloqueio,
            horario: h,
            dia: d.num,
            cliente: 'Bloqueado', telefone: '',
            servico: 'Bloqueado', preco: 'R$ 0',
            status: 'bloqueado', tipo: 'manual'
          });
        });
      });
    }
    return lista;
  }

  function handleSalvar() {
    if (tipo === 'bloqueado') {
      if (periodoBlock === 'horario') {
        onSalvar({
          barbeiro: barbeiroBloqueio, horario, dia,
          cliente: 'Bloqueado', telefone: '',
          servico: 'Bloqueado', preco: 'R$ 0',
          status: 'bloqueado', tipo: 'manual'
        });
      } else {
        const lista = gerarListaBloqueio();
        if (lista.length === 0) return;
        const conflitos = todosAgends.filter(a =>
          a.barbeiro === barbeiroBloqueio &&
          a.status !== 'bloqueado' &&
          lista.some(l => l.dia === a.dia && l.horario === a.horario)
        );
        if (conflitos.length > 0) {
          setConfirmPeriodo({ conflitos, lista });
        } else {
          onSalvarMultiplos(lista);
        }
      }
      return;
    }
    if (!nome) return;
    onSalvar({
      barbeiro, horario, dia,
      cliente: nome, telefone: formatTelefone(telefoneRaw), servico, preco,
      status: 'confirmado', tipo: 'manual'
    });
  }

  function confirmarPeriodoCancelar() {
    if (!confirmPeriodo) return;
    onSalvarMultiplos(confirmPeriodo.lista);
    setConfirmPeriodo(null);
  }

  function confirmarPeriodoLivres() {
    if (!confirmPeriodo) return;
    const livres = confirmPeriodo.lista.filter(l =>
      !confirmPeriodo.conflitos.some(c => c.dia === l.dia && c.horario === l.horario)
    );
    if (livres.length > 0) onSalvarMultiplos(livres);
    setConfirmPeriodo(null);
  }

  const labelBotao = () => {
    if (tipo !== 'bloqueado') return 'Confirmar agendamento';
    if (periodoBlock === 'horario') return 'Bloquear este horário';
    if (!dataInicio) return 'Selecione a data de início';
    if (!dataFim) return `Bloqueio: ${dataInicio.dia}/${meses.indexOf(dataInicio.mes) + 1} (selecione o fim)`;
    return `Bloquear ${dataInicio.dia}/${meses.indexOf(dataInicio.mes) + 1} até ${dataFim.dia}/${meses.indexOf(dataFim.mes) + 1}`;
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      zIndex: 999, fontFamily: 'Arial, sans-serif', isolation: 'isolate'
    }}>
      <div style={{
        width: '100%', maxWidth: '480px',
        backgroundColor: '#181818', borderRadius: '20px 20px 0 0',
        padding: '24px', borderTop: '0.5px solid #252525',
        maxHeight: '90vh', overflowY: 'auto', position: 'relative'
      }}>
        <div style={{ width: '40px', height: '4px', backgroundColor: '#333', borderRadius: '2px', margin: '0 auto 20px' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#e8e8e8', margin: 0 }}>
            {tipo === 'bloqueado' ? 'Bloquear agenda' : 'Marcar horário'}
          </h3>
          <span onClick={onFechar} style={{ fontSize: '20px', color: '#8f8f8f', cursor: 'pointer' }}>×</span>
        </div>
        <p style={{ fontSize: '12px', color: '#8f8f8f', marginBottom: '20px' }}>
          {tipo === 'bloqueado' ? barbeiroBloqueio : barbeiro}{!periodoBlockInicial ? ` · ${horario} · dia ${dia}` : ''}
        </p>

        {/* ── Tipo ── só exibe quando não foi aberto direto em modo período */}
        {!periodoBlockInicial && (
          <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
            {[
              { id: 'cliente',   label: 'Agendamento' },
              { id: 'bloqueado', label: 'Bloqueio'    },
            ].map(t => (
              <button key={t.id} onClick={() => setTipo(t.id)} style={{
                flex: 1, padding: '9px',
                backgroundColor: tipo === t.id ? (t.id === 'bloqueado' ? '#2a1515' : '#1a2a1a') : '#111',
                color: tipo === t.id ? (t.id === 'bloqueado' ? '#e05555' : '#7bc47b') : '#555',
                border: `0.5px solid ${tipo === t.id ? (t.id === 'bloqueado' ? '#3d1a1a' : '#2d4a2d') : '#252525'}`,
                borderRadius: '10px', cursor: 'pointer',
                fontSize: '12px', fontWeight: '600', fontFamily: 'Arial, sans-serif'
              }}>
                {t.label}
              </button>
            ))}
          </div>
        )}

        {/* ══ AGENDAMENTO ══ */}
        {tipo !== 'bloqueado' ? (
          <>
            {/* Nome */}
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Nome do cliente</label>
              <input
                value={nome}
                onChange={e => setNome(e.target.value)}
                placeholder="Nome completo"
                style={inputStyle}
              />
            </div>

            {/* Telefone */}
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Telefone (opcional)</label>
              <input
                value={formatTelefone(telefoneRaw)}
                onChange={e => setTelefoneRaw(e.target.value.replace(/\D/g, ''))}
                placeholder="(51) 99999-9999"
                inputMode="numeric"
                style={inputStyle}
              />
            </div>

            {/* Serviços — dados reais */}
            <div style={{ marginBottom: '20px' }}>
              <label style={labelStyle}>Serviço</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {servicos.map(s => (
                  <div key={s.nome}
                    onClick={() => { setServico(s.nome); setPreco(s.preco); }}
                    style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      padding: '10px 12px', borderRadius: '8px', cursor: 'pointer',
                      backgroundColor: servico === s.nome ? '#1a2a1a' : '#111',
                      border: `0.5px solid ${servico === s.nome ? '#2d4a2d' : '#252525'}`
                    }}>
                    <span style={{ fontSize: '13px', color: servico === s.nome ? '#7bc47b' : '#ccc' }}>{s.nome}</span>
                    <span style={{ fontSize: '13px', color: '#c9a84c' }}>{s.preco}</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            {/* ══ BLOQUEIO ══ */}

            {/* Barbeiro — dados reais */}
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Bloquear agenda de</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {barbeiros.map(b => (
                  <div key={b}
                    onClick={() => setBarbeiroBloqueio(b)}
                    style={{
                      padding: '10px 12px', borderRadius: '8px', cursor: 'pointer',
                      backgroundColor: barbeiroBloqueio === b ? '#2a1515' : '#111',
                      border: `0.5px solid ${barbeiroBloqueio === b ? '#3d1a1a' : '#252525'}`,
                      fontSize: '13px', color: barbeiroBloqueio === b ? '#e05555' : '#ccc'
                    }}>
                    {b}
                  </div>
                ))}
              </div>
            </div>

            {/* Período — toggle só aparece quando não aberto direto em modo período */}
            {!periodoBlockInicial && (
              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>Tipo de bloqueio</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[
                    { id: 'horario', label: 'Este horário' },
                    { id: 'periodo', label: 'Período de datas' },
                  ].map(p => (
                    <button key={p.id}
                      onClick={() => { setPeriodoBlock(p.id); setDataInicio(null); setDataFim(null); setSelecionando('inicio'); }}
                      style={{
                        flex: 1, padding: '8px',
                        backgroundColor: periodoBlock === p.id ? '#2a1515' : '#111',
                        color: periodoBlock === p.id ? '#e05555' : '#555',
                        border: `0.5px solid ${periodoBlock === p.id ? '#3d1a1a' : '#252525'}`,
                        borderRadius: '8px', cursor: 'pointer',
                        fontSize: '12px', fontFamily: 'Arial, sans-serif'
                      }}>
                      {p.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Calendário de seleção de período */}
            {periodoBlock === 'periodo' && (
              <div style={{ marginBottom: '16px' }}>

                {/* Indicador início/fim */}
                <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                  {[
                    { id: 'inicio', data: dataInicio, label: 'Início' },
                    { id: 'fim',    data: dataFim,    label: 'Fim'    },
                  ].map(({ id, data, label }) => (
                    <div key={id} style={{
                      flex: 1, padding: '8px 12px', borderRadius: '8px', textAlign: 'center',
                      backgroundColor: selecionando === id ? '#2a1515' : '#111',
                      border: `0.5px solid ${data ? '#3d1a1a' : '#252525'}`
                    }}>
                      <div style={{ fontSize: '9px', color: '#8f8f8f', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '1px' }}>{label}</div>
                      <div style={{ fontSize: '13px', color: data ? '#e05555' : '#444', fontWeight: '600' }}>
                        {data ? `${data.dia}/${meses.indexOf(data.mes) + 1}` : '— —'}
                      </div>
                    </div>
                  ))}
                  <div style={{ display: 'flex', alignItems: 'center', color: '#333', fontSize: '18px' }}>→</div>
                </div>

                <p style={{ fontSize: '11px', color: '#8f8f8f', marginBottom: '6px', textAlign: 'center' }}>
                  {selecionando === 'inicio' ? 'Toque na data de início do bloqueio' : 'Toque na data de fim do bloqueio'}
                </p>

                {/* Seletor de mês */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                  <span
                    onClick={() => { if (mesIdx > 0) setMesSeletor(meses[mesIdx - 1]); }}
                    style={{ fontSize: '18px', color: mesIdx > 0 ? '#7bc47b' : '#333', cursor: 'pointer', padding: '0 8px' }}>‹</span>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#e8e8e8' }}>{mesSeletor}</span>
                  <span
                    onClick={() => { if (mesIdx < meses.length - 1) setMesSeletor(meses[mesIdx + 1]); }}
                    style={{ fontSize: '18px', color: mesIdx < meses.length - 1 ? '#7bc47b' : '#333', cursor: 'pointer', padding: '0 8px' }}>›</span>
                </div>

                {/* Header dias da semana */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px', marginBottom: '2px' }}>
                  {['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].map(d => (
                    <div key={d} style={{ textAlign: 'center', fontSize: '9px', color: '#7d7d7d', padding: '1px 0' }}>{d}</div>
                  ))}
                </div>

                {/* Grid de dias com offset */}
                {(() => {
                  const ano    = new Date().getFullYear();
                  const offset = new Date(ano, mesIdx, 1).getDay();
                  const cells  = [];
                  for (let i = 0; i < offset; i++) {
                    cells.push(<div key={`empty-${i}`} />);
                  }
                  const _hoje = new Date();
                  const _hojeZero = new Date(_hoje.getFullYear(), _hoje.getMonth(), _hoje.getDate());
                  diasDoMes.forEach((d, i) => {
                    const ano = new Date().getFullYear();
                    const dt = new Date(ano, mesIdx, parseInt(d.num));
                    const passado = dt < _hojeZero;
                    const inicio = isInicio(mesSeletor, d.num);
                    const fim    = isFim(mesSeletor, d.num);
                    const range  = isDentroDoRange(mesSeletor, d.num);
                    cells.push(
                      <div key={i}
                        onClick={() => !passado && selecionarDia(mesSeletor, d.num)}
                        style={{
                          textAlign: 'center', padding: '4px 1px', borderRadius: '5px',
                          cursor: passado ? 'not-allowed' : 'pointer',
                          opacity: passado ? 0.5 : 1,
                          backgroundColor: passado ? 'transparent' : inicio || fim ? '#3d1a1a' : range ? '#2a1515' : '#111',
                          border: `0.5px solid ${passado ? 'transparent' : inicio || fim ? '#e05555' : range ? '#3d1a1a' : '#1e1e1e'}`
                        }}>
                        <span style={{
                          fontSize: '12px',
                          fontWeight: inicio || fim ? '700' : '400',
                          color: passado ? '#555' : inicio || fim ? '#e05555' : range ? '#c07070' : '#888'
                        }}>
                          {d.num}
                        </span>
                      </div>
                    );
                  });
                  return (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px' }}>
                      {cells}
                    </div>
                  );
                })()}

                {dataInicio && (
                  <div style={{ textAlign: 'right', marginTop: '8px' }}>
                    <span
                      onClick={() => { setDataInicio(null); setDataFim(null); setSelecionando('inicio'); }}
                      style={{ fontSize: '11px', color: '#8f8f8f', cursor: 'pointer', textDecoration: 'underline' }}>
                      Limpar seleção
                    </span>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        <button
          onClick={handleSalvar}
          disabled={tipo !== 'bloqueado' ? !nome : (periodoBlock === 'periodo' && !dataInicio)}
          style={{
            width: '100%',
            backgroundColor: tipo === 'bloqueado' ? '#2a1515' : '#2d4a2d',
            color: tipo === 'bloqueado' ? '#e05555' : '#7bc47b',
            border: 'none', borderRadius: '12px', padding: '14px',
            fontSize: '13px', fontWeight: '600', cursor: 'pointer',
            fontFamily: 'Arial, sans-serif',
            opacity: (tipo !== 'bloqueado' ? !nome : (periodoBlock === 'periodo' && !dataInicio)) ? 0.4 : 1
          }}>
          {labelBotao()}
        </button>
      </div>

      {/* Modal: conflitos no período de bloqueio */}
      {confirmPeriodo && (
        <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.92)', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', borderRadius: '20px 20px 0 0' }}>
          <div style={{ backgroundColor: '#1a1a1a', borderRadius: '14px', border: '0.5px solid #4a1a1a', padding: '20px', width: '100%' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#e05555', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '10px' }}>
              ⚠️ Há {confirmPeriodo.conflitos.length} reserva{confirmPeriodo.conflitos.length > 1 ? 's' : ''} neste período
            </div>
            <p style={{ fontSize: '13px', color: '#ccc', marginBottom: '16px', lineHeight: '1.5' }}>
              O período selecionado contém {confirmPeriodo.conflitos.length} agendamento{confirmPeriodo.conflitos.length > 1 ? 's' : ''} confirmado{confirmPeriodo.conflitos.length > 1 ? 's' : ''}. Como deseja prosseguir?
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <button onClick={confirmarPeriodoCancelar} style={{
                padding: '12px', borderRadius: '10px', border: 'none', cursor: 'pointer',
                backgroundColor: '#3d1a1a', color: '#e05555',
                fontSize: '13px', fontWeight: '600', fontFamily: 'Arial, sans-serif'
              }}>
                Cancelar as {confirmPeriodo.conflitos.length} reservas e bloquear tudo
              </button>
              <button onClick={confirmarPeriodoLivres} style={{
                padding: '12px', borderRadius: '10px', border: '0.5px solid #2a1515', cursor: 'pointer',
                backgroundColor: '#111', color: '#e05555',
                fontSize: '13px', fontFamily: 'Arial, sans-serif'
              }}>
                Bloquear apenas os horários livres
              </button>
              <button onClick={() => setConfirmPeriodo(null)} style={{
                padding: '10px', borderRadius: '10px', border: '0.5px solid #252525', cursor: 'pointer',
                backgroundColor: 'transparent', color: '#8f8f8f',
                fontSize: '12px', fontFamily: 'Arial, sans-serif'
              }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AgendamentoManual;
